module.exports = __webpack_public_path__ + "static/media/directionsappimage.4bd4d22d.jpg";